/* eslint-disable no-console */
// @flow
import {Rox} from 'rox-ssr';

/**
 * Show Rollout Flags Callback
 */
export function showRolloutFlagsCallback() {
    try {
        Rox.showOverrides();
    } catch (error) {
        console.error('Could not show Rollout flags', error);
    }
}

/**
 * Adds an event listener
 */
export function addRolloutEventListener() {
    window.addEventListener('rollout-trigger:showFlags', showRolloutFlagsCallback);
}
